module.exports = __webpack_public_path__ + "media/images/video-bg-996e3b1dc69829681f20b3c21d55a76b.png";